import { useEffect, useState } from "react";

/**
 * `value`, updated only once it has stopped changing for `delayMs`.
 *
 * Search-as-you-type keys its query on this, so typing "gokul" sends one request after the
 * pause instead of one per keystroke (q=go, gok, goku, gokul — each with its own CORS preflight).
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
